/**
 * Converts Persian/Arabic digits to English digits
 * @param {string} input - String containing Persian/Arabic digits
 * @returns {string} - String with English digits
 */
export function normalizeDigits(input) {
  if (!input || typeof input !== 'string') return input;

  const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
  const arabicDigits = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];
  const englishDigits = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

  let output = input;

  // Replace Persian digits
  persianDigits.forEach((digit, index) => {
    output = output.replace(new RegExp(digit, 'g'), englishDigits[index]);
  });

  // Replace Arabic digits
  arabicDigits.forEach((digit, index) => {
    output = output.replace(new RegExp(digit, 'g'), englishDigits[index]);
  });

  return output;
}

/**
 * Normalize digits in event handler
 * Usage: onChange={(e) => handleNormalizedInput(e, setValue)}
 */
export function handleNormalizedInput(event, setter) {
  const normalized = normalizeDigits(event.target.value);
  setter(normalized);
}
